import { render, staticRenderFns } from "./UserAvatar.html?vue&type=template&id=53f99c8a&scoped=true&external"
import script from "./UserAvatar.vue?vue&type=script&lang=js"
export * from "./UserAvatar.vue?vue&type=script&lang=js"
import style0 from "./UserAvatar.scss?vue&type=style&index=0&id=53f99c8a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f99c8a",
  null
  
)

export default component.exports